import Vue from 'vue'
import Vuex from 'vuex'
import common, { CommonState } from './modules/common'
import ingredients, { IngredientState } from './modules/ingredients'
import products, { ProductState } from './modules/products'
import reports, { ReportState } from './modules/reports'
import user, { UserState } from './modules/user'
import company, { CompanyState } from './modules/company'
import projects, { ProjectState } from './modules/projects'
import projectIngredients, { ProjectIngredientState } from './modules/projectIngredients'
import templates, { TemplateState } from './modules/templates'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export interface RootState {
  common: CommonState;
  products: ProductState;
  ingredients: IngredientState;
  reports: ReportState;
  user: UserState;
  company: CompanyState;
  projects: ProjectState;
  projectIngredients: ProjectIngredientState;
  templates: TemplateState;
}

export default new Vuex.Store<RootState>({
  modules: {
    common,
    ingredients,
    products,
    reports,
    user,
    company,
    projects,
    projectIngredients,
    templates,
  },
  strict: debug,
})
